import { ApplicationErrorPage } from "@src/pages/ApplicationError";
import { PageNotFoundError } from "@src/pages/DashboardNotFound";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

/**
 * Root error boundary for the data router.
 *
 * Per React Router v6 best practices, when no route matches a URL React Router
 * automatically throws a 404 `Response` that bubbles up to the nearest
 * `errorElement` rather than relying on a splat (`*`) route. This boundary
 * routes a thrown 404 to the dedicated not-found page and falls back to a
 * styled application-error page for any other error so the UI never breaks
 * out of the design system.
 *
 * @see https://reactrouter.com/6.30.3/route/error-element
 */
export function ErrorBoundary() {
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;

  if (!is404) {
    console.error("[ErrorBoundary] Unhandled route error:", error);
  }

  if (is404) {
    return <PageNotFoundError />;
  }

  return <ApplicationErrorPage />;
}
